const PROXY_URL = 'https://ps.movemaestro.com/v3/mmapi/'; 
const TWS_LOGIN = 'https://tolltwsfunctions-pt.azurewebsites.net/api/twslogin';
const TWS_FORGOT_LOGIN = 'https://tolltwsfunctions-pt.azurewebsites.net/api/TWSForgotLogin'; 
const TWS_REGISTER = 'https://tolltwsfunctions-pt.azurewebsites.net/api/twsregister?client=uniform';
const TWS_CIVIL_REGISTER = 'https://tolltwsfunctions-pt.azurewebsites.net/api/twsregister?client=civilian'; 
const QAS = 'https://tolltwsfunctions-pt.azurewebsites.net/api/QAS'; 
const AAD = 'amovemaestro.onmicrosoft.com';

module.exports = {
    PROXY_URL
    ,TWS_LOGIN
    ,TWS_FORGOT_LOGIN
    ,TWS_REGISTER
    ,QAS
    ,AAD
    ,TWS_CIVIL_REGISTER
}